import { render, staticRenderFns } from "./profile_disconect.vue?vue&type=template&id=a5ecfd58&scoped=true"
import script from "./profile_disconect.vue?vue&type=script&lang=js"
export * from "./profile_disconect.vue?vue&type=script&lang=js"
import style0 from "./profile_disconect.vue?vue&type=style&index=0&id=a5ecfd58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ecfd58",
  null
  
)

export default component.exports